import { CatalogReportActions } from "@ext/catalog/report/components/CatalogReportActions";
import { CatalogReportContent } from "@ext/catalog/report/components/CatalogReportContent";
import { useCatalogReportSettings } from "@ext/catalog/report/logic/useCatalogReportSettings";
import { CATALOG_REPORT_PANEL_ID } from "@ext/catalog/report/models/consts";
import t from "@ext/localization/locale/translate";
import { ViewSurfaceVariantProvider } from "@ext/markdown/elements/view/models/ViewSurfaceVariant";
import { useUpdateViewArticle } from "@ext/markdown/elements/view/render/logic/hooks/useUpdateViewArticle";
import { FloatingPanel } from "@ui-kit/FloatingPanel";
import { ComponentVariantProvider } from "@ui-kit/Providers";

export const CatalogReportPanel = () => {
	const { settings } = useCatalogReportSettings();
	const updateArticle = useUpdateViewArticle();

	return (
		<ComponentVariantProvider variant="glass">
			<ViewSurfaceVariantProvider variant="panel">
				<FloatingPanel
					headerActions={<CatalogReportActions />}
					icon="chart-no-axes-column"
					id={CATALOG_REPORT_PANEL_ID}
					title={t("catalog.report.name")}
				>
					<CatalogReportContent settings={settings} updateArticle={updateArticle} />
				</FloatingPanel>
			</ViewSurfaceVariantProvider>
		</ComponentVariantProvider>
	);
};
